const gsap = window.gsap;

if (gsap !== undefined) {
  gsap.utils.toArray(".section_testimonial").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const y = (self.progress - 0.5) * 50;
        gsap.set(el, { "--y": y + "px" });
      },
    });
  });

  gsap.from(".section_testimonial .section-text", {
    autoAlpha: 0,
    x: -200,
    opacity: 0,
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_testimonial",
      start: "top 80%",
    },
  });

  gsap.from(".section_testimonial .section-title", {
    autoAlpha: 0,
    x: -200,
    opacity: 0,
    duration: 1,
    delay: 0.2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_testimonial",
      start: "top 80%",
    },
  });
}
